import { FormControl } from '@angular/forms';
import { MappingType } from '@src/api/reports';

export interface FormDataType {
  parameter: string;
  source: FormValueType;
  format: string | null;
}

export interface FormType {
  parameter: FormControl<string>;
  source: FormControl<FormValueType>;
  format: FormControl<string | null>;
}

export type FormValueType = MappingType;
export const FormValueType = MappingType;
